
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.765","height":"19.818"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","transform":"translate(.75 .75)","data-name":"contact us"}},[_c('path',{attrs:{"data-name":"Path 238","d":"M15.265 18.318v-2.035a4.071 4.071 0 00-4.07-4.071H4.071A4.071 4.071 0 000 16.283v2.035"}}),_c('circle',{attrs:{"data-name":"Ellipse 70","cx":"4.071","cy":"4.071","r":"4.071","transform":"translate(3.562)"}})])])
          )
        }
      }
    